module.exports = __webpack_public_path__ + "img/logo.d0df5543.png";